import { Alert } from "antd"
import { useIsRecoveryComponentEnabled } from "../../domain/invoicing/settings/recoveryComponentQueries"
import { formatDollars } from "./budgetCalculatorModel"
import { OverheadGroup, findChargedCardProcessingOverhead } from "./overheadModel"

type Props = {
  overheadGroups: OverheadGroup[]
}

const CardProcessingOverheadNotice = ({ overheadGroups }: Props) => {
  const isPassingOnPaymentFees = useIsRecoveryComponentEnabled()

  if (!isPassingOnPaymentFees) {
    return null
  }

  const charged = findChargedCardProcessingOverhead(overheadGroups)

  return <Alert
    type="info"
    showIcon
    message="Customers who pay by card or bank transfer cover their own fees"
    description={<>
      <div>
        Pass On Payment Fees is on by default, so credit card and bank transfer payments add a surcharge at checkout.
        Your overhead only needs to cover payments that aren't surcharged: debit and prepaid cards, fees above the
        surcharge cap, and jobs with Pass On Payment Fees turned off.
      </div>
      {charged.length > 0 && <>
        <div>Check that these lines only cover that share:</div>
        <ul>
          {charged.map(x => <li key={`${x.groupName}-${x.index}`}>
            {x.groupName} &mdash; {x.description} ({formatDollars(x.annualCost)} a year)
          </li>)}
        </ul>
      </>}
    </>}
  />
}

export default CardProcessingOverheadNotice
